import type { Session } from "./types";

export const API = (import.meta.env.VITE_API_URL || "http://localhost:4000").replace(/\/$/, "");
async function request<T>(path: string, init: RequestInit = {}) {
  const response = await fetch(`${API}${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...init.headers },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok)
    throw Object.assign(new Error(data.error || "Something went wrong"), {
      code: data.error,
      data,
    });
  return data as T;
}
export const api = {
  name: (code?: string) =>
    request<{ nickname: string }>(`/v1/names${code ? `?code=${encodeURIComponent(code)}` : ""}`),
  create: (nickname?: string, pin?: string) =>
    request<Session>("/v1/rooms", {
      method: "POST",
      body: JSON.stringify({ nickname, pin: pin || undefined }),
    }),
  preview: (code: string) => request<{ room: Session["room"] }>(`/v1/rooms/${code}`),
  join: (code: string, nickname: string, pin?: string) =>
    request<Session>(`/v1/rooms/${code}/join`, {
      method: "POST",
      body: JSON.stringify({ nickname, pin: pin || undefined }),
    }),
  restore: (code: string, sessionToken: string) =>
    request<Omit<Session, "sessionToken">>(`/v1/rooms/${code}/restore`, {
      method: "POST",
      body: JSON.stringify({ sessionToken }),
    }),
  history: (code: string, token: string) =>
    request<any>(`/v1/rooms/${code}/messages`, { headers: { Authorization: `Bearer ${token}` } }),
  upload: async (code: string, token: string, file: File) => {
    const response = await fetch(`${API}/v1/rooms/${code}/uploads`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": file.type || "application/octet-stream",
        "X-File-Name": encodeURIComponent(file.name),
        "X-File-Type": file.type || "application/octet-stream",
      },
      body: file,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok)
      throw Object.assign(new Error(data.error || "Upload failed"), { code: data.error });
    return data as { key: string };
  },
  fileUrl: async (code: string, token: string, id: string) => {
    const response = await fetch(`${API}/v1/rooms/${code}/files/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Download failed");
    return { url: URL.createObjectURL(await response.blob()) };
  },
};
export const storeSession = (code: string, session: Session) =>
  localStorage.setItem(
    `tempchat:${code}`,
    JSON.stringify({ sessionToken: session.sessionToken, adminToken: session.adminToken }),
  );
export const getStored = (code: string) => {
  try {
    return JSON.parse(localStorage.getItem(`tempchat:${code}`) || "null");
  } catch {
    return null;
  }
};
